namespace GeniuzPOS.SalePromoCamp {
    export enum PromoItemType {
        ProdCode = 1,
        StyleCode = 2,
        CategoryCode = 3,
        Category2Code = 4,
        Category3Code = 5
    }
    Serenity.Decorators.registerEnumType(PromoItemType, 'GeniuzPOS.SalePromoCamp.PromoItemType', 'SalePromoCamp.PromoItemType');
}
